module.exports = __webpack_public_path__ + "media/bootstrap-icons/justify-right-0b2fd549.svg";